var myArrow;

function bulkToggle() {
  var x = document.getElementById("bulk-pricing-info");
  if (x.style.display == "none") {
    x.style.display = "block";
    myArrow  = document.getElementsByClassName("down")[0];
     myArrow.className = "up";
  } else {
    x.style.display = "none";
    myArrow  = document.getElementsByClassName("up")[0];
     myArrow.className = "down";
  }
}